if (!customElements.get('gx-quickview-dots')) {
  customElements.define(
    'gx-quickview-dots',
    class GxQuickviewDots extends HTMLElement {
      connectedCallback() {
        this.sliderComponent = this.closest('slider-component');

        if (!this.sliderComponent) return;

        this.slides = Array.from(
          this.sliderComponent.querySelectorAll('[id^="Slide-"]')
        ).filter((slide) => !slide.hasAttribute('hidden'));

        if (this.slides.length < 2) {
          this.hidden = true;
          return;
        }

        this.hidden = false;
        this.innerHTML = '';
        this.removeAttribute('role');
        this.setAttribute('aria-hidden', 'true');

        this.slides.forEach((slide, index) => {
          const dot = document.createElement('span');

          dot.className = 'gx-quickview-dots__dot';

          if (
            slide.classList.contains('is-active') ||
            (index === 0 &&
              !this.slides.some((item) =>
                item.classList.contains('is-active')
              ))
          ) {
            dot.classList.add('is-active');
          }

          this.appendChild(dot);
        });

        this.dots = Array.from(
          this.querySelectorAll('.gx-quickview-dots__dot')
        );

        this.handleSlideChange = (event) => {
          const currentPage = Number(event.detail?.currentPage || 1);
          const activeIndex = Math.max(
            0,
            Math.min(currentPage - 1, this.dots.length - 1)
          );

          this.dots.forEach((dot, index) => {
            dot.classList.toggle('is-active', index === activeIndex);
          });
        };

        this.sliderComponent.addEventListener(
          'slideChanged',
          this.handleSlideChange
        );
      }

      disconnectedCallback() {
        if (this.sliderComponent && this.handleSlideChange) {
          this.sliderComponent.removeEventListener(
            'slideChanged',
            this.handleSlideChange
          );
        }
      }
    }
  );
}